module.exports = __webpack_public_path__ + "static/media/pepper_jack.722d830d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pepper_jack.png
// module id = 74
// module chunks = 0